<head>
  <style>
    .mbfs-home-hero {
      background-image: url('/static/assets/img/dtf-assets/images/redesign/Careers_Top_Banner_2281x625.jpg');
      width: 100%;
      height: 500px;
    }

  .hero-text {
    display: none;
   }

  @media (max-width: 667px) {
    .mbfs-home-hero {
      background-image: url('/static/assets/img/dtf-assets/images/redesign/Mobile_Careers_Black.jpg');
      width: 100%;
      height: 550px;
      background-position: center;
      background-size: cover;
      position: relative; /* important for positioning text */
    }

    .hero-text {
      position: absolute;
      top: 50px;
      bottom: 20px; /* adjust as needed */
      left: 20px;
      right: 20px;
      color: #fff;
      font-size: 30px;
      font-family: 'corporateSRegular';
      line-height: 1.4;
      display: block !important;
    }
  }

  

    h4 {
      color: black;
      font-family: 'corporateSRegular';
      margin: 100px 150px 100px 150px;
    }

    .mbfs-repay-banner-inner__header-title {
      font-size: 2.374rem;
    }

    footer [role=contentinfo] .mbfs-copyright {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .connected-insurance {
      max-width: 600px;
      /* limit max width */
      margin-right: auto;
      /* push it to left */
      margin-left: 160px;
      /* add some space from left */
      padding-top: 100px;
    }

    .connected-insurance h2 {
      font-family: 'corporateERegular';
      font-weight: bold;
      font-size: 60px;
      color: black;
      text-align: left;
      /* left align text */
      margin: 0 0 20px 0;
    }

    .connected-insurance p {
      font-family: 'CorporateSDemiRegular';
      font-weight: lighter;
      line-height: 1em;
      font-size: 35px;
      color: black;
      width: 400px;
      text-align: center;
      margin-left: 50px;
    }

    @media (max-width: 768px) {
    .row {
      display: flex;
      flex-direction: column;
    }
    .col-8,
    .col-4,
    .col-5,
    .col-3,
    .col {
      width: 100% !important;
      max-width: 100%;
      flex: 0 0 100%;
    }
    /* Remove large left margins */
    .mbfs-repay-banner-inner__box {
      margin-left: 0 !important;
      padding: 10px;
    }
    /* Reduce heading sizes */
    h4 {
      font-size: 16px !important;
      line-height: 1.5;
    }
    .mbfs-repay-banner-inner__box--text2 p {
      font-size: 18px !important;
    }
    /* Fix large titles */
    .mbfs-repay-banner-inner__box--text2 p[style*="40px"],
    .mbfs-repay-banner-inner__box--text2 p[style*="45px"] {
      font-size: 22px !important;
    }
    /* Images responsive */
    img.logo {
      width: 100% !important;
      height: auto;
      padding-left: 38px;
      padding-right: 38px;
    }
    /* Center images that had margin-left */
    img[style*="margin-left"] {
      margin-left: 0 !important;
    }
    /* Fix button */
    .mbfs-button-1 {
      width: 100%;
      padding: 12px;
      font-size: 16px;
    }
    /* Section spacing */
    section.mbfs-repay-banner-inner {
      padding: 18px !important;
      flex-direction: column !important;
    }
    /* Text alignment fix */
    .mbfs-repay-banner-inner__box--text2 {
      text-align: center;
    }
  }
  @media (max-width: 768px) {
    /* Make this section full width */
    .row .col-8 {
      width: 100% !important;
      flex: 0 0 100%;
      max-width: 100%;
      padding: 0 15px;
    }
    /* Fix the long paragraph */
    .row .col-8 h4 {
      font-size: 18px !important;
      line-height: 1.6;
      text-align: left;
      margin: 20px;
    }
    /* Improve spacing between paragraphs */
    .row .col-8 h4 br {
      display: block;
      margin-bottom: 8px;
      content: "";
    }
  }
  /* Mobile view adjustments */
@media (max-width: 768px) {
  .mbfs-repay-banner-inner__box--text2 {
    width: 100% !important;       /* full width on mobile */
    margin-left: 0 !important;    /* remove desktop margin */
    padding: 0 15px;              /* some padding for breathing room */
  }

  .mbfs-repay-banner-inner__box--text2 .row {
    display: flex;
    flex-direction: column;       /* stack image above text */
    text-align: left;             /* keep text left-aligned */
    margin-bottom: 30px;          /* spacing between rows */
  }

  .mbfs-repay-banner-inner__box--text2 .col-3,
  .mbfs-repay-banner-inner__box--text2 .col-7 {
    flex: 1 1 100%;               /* make columns full width */
    max-width: 100%;
  }

  .mbfs-repay-banner-inner__box--text2 img.logo {
    width: 100%;                  /* image scales full width */
    height: auto;
    margin-bottom: 20px;          /* space below image */
  }

  .mbfs-repay-banner-inner__box--text2 p {
    font-size: 20px !important;   /* smaller font for mobile */
    line-height: 1.6;
  }

  .mbfs-repay-banner-inner p {
    font-size: 24px;              /* banner title font adjustment */
    text-align: left;             /* keep title left-aligned */
  }
}
/* Mobile view adjustments */
@media (max-width: 768px) {

  .mbfs-repay-banner-inner__box {
    margin-left: 0 !important;    /* remove desktop margin */
    padding: 0 15px;              /* add some padding */
    width: 100% !important;
  }

  .mbfs-repay-banner-inner__box--text2 p {
    text-align: left !important;  /* keep all text left-aligned */
  }

  .mbfs-repay-banner-inner__box--text2 .row {
    display: flex;
    flex-direction: column;       /* stack image above text */
    margin-bottom: 30px;          /* space between sections */
  }

  .mbfs-repay-banner-inner__box--text2 .col-3,
  .mbfs-repay-banner-inner__box--text2 .col {
    flex: 1 1 100%;               /* full width for image and text */
    max-width: 100%;
    text-align: left !important;
  }

  .mbfs-repay-banner-inner__box--text2 img.logo {
    width: 100%;                  /* image full width */
    height: auto;
    margin-bottom: 15px;          /* spacing below image */
  }

  .mbfs-repay-banner-inner__box--text2 p {
    font-size: 18px !important;   /* readable font size for mobile */
    line-height: 1.5;
  }

  .mbfs-repay-banner-inner__box--text2 p[style*="font-size: 45px"] {
    font-size: 28px !important;   /* section title smaller on mobile */
  }

  .mbfs-repay-banner-inner__box--text2 p[style*="font-size: 25px"] {
    font-size: 20px !important;   /* subtitle smaller on mobile */
  }

  .mbfs-repay-banner-inner__box--text2 p[style*="font-size: 26px"] {
    font-size: 22px !important;   /* subheading smaller on mobile */
  }
}
.image-button-wrap {
  position: relative;
  display: inline-block;
}

.image-button-wrap img {
  display: block;
  width: 100%;
  height: auto;
  margin-top: 10px;
}

.image-button-wrap .mbfs-button {
  position: absolute;
  bottom: 20px;   /* adjust vertical position */
  left: 50%;
  transform: translateX(-50%);
  background-color: #00566A;
  color: #fff;
  padding: 12px 20px;
  border: none;
  cursor: pointer;
  width: 70%;
}
  </style>
</head>

<body>

  <div class="dtf-insurance">

    <div class="dtf-alertpage"></div>

    <!--Banner-->
    <section class="mbfs-home-hero">
      <section class="connected-insurance">
       <div style="color: white;" class="hero-text">
            Accelerate your career at Daimler Truck Financial Services.
          </div>
      </section>
    </section>

   


    <div class="row">
      <div class="col-8">
        <h4 style="margin-top: 10px;"> <span style="font-weight: bold;">It’s a career with purpose—and a chance to help Move the World.</span> <br><br> At DTFS, you’ll
          find the support, balance and resources you need to build a meaningful career and shape a future filled with
          possibility—including your own. Here, purpose and performance move in the same direction.
          We are part of a global company with a long legacy of strength and stability, but we’re not defined by history alone.
          <br><br> We’re ambitious. We’re growing. And we’re committed to creating a better future for our people, our customers
          and the communities we serve. Backed by the global scale of Daimler Truck, we have the experience and financial
          strength to make bold progress happen. <br><br><span style="font-weight: bold;"> And our reach extends across North
          America.</span> <br><br> Beyond our growing presence in the United States, Daimler Truck Financial Services operates
          across the region—with established offices in Canada, the United States and Mexico. This North American footprint
          allows us to support customers, dealers, and communities with the strength of a unified, international team—all
          working together to help Move the World. <br><br>
          Join us as we build what’s next at Daimler Truck Financial Services—and help us move the world.
        </h4>
        </div>
      <div class="col-3" style="display: block; margin-top: 20px;">
        <img src="/static/assets/img/dtf-assets/images/redesign/YouMakeUs.png" alt="Logo" class="logo" />
        <a href="https://northamerica.daimlertruck.com/careers/" target="_blank" class="image-button-wrap">
          <img src="/static/assets/img/dtf-assets/images/redesign/JobListing.png" alt="Logo" class="logo" />
          <button class="mbfs-button">View Current Job Postings</button>
        </a>
      </div>
    </div>

    <section class='mbfs-repay-banner-inner' style="background-color: #E6E6E6; display: flex; color: black;">
      <div class="mbfs-repay-banner-inner__box" style="margin-left: 130px;">
        <div class="mbfs-repay-banner-inner__box--text2" style="width: 150%;">
          <p style="text-align: left; font-size: 40px;">Building Our Future in Ballantyne</p>
          <div class="row" style="text-align: left;">

            <div class="col-3">
              <img src="/static/assets/img/dtf-assets/images/redesign/Ballantyne_Building.jpg" alt="Logo"
                class="logo" />
            </div>

            <div class="col-7" style="color: black; text-align: left; font-size: 24px; font-family: 'corporateSRegular';">
              <p>Our new Ballantyne office is in one of the area’s premier developments, offering a vibrant, modern environment
                designed for how people work and thrive today. Set within a highly walkable district surrounded by dining, retail,
                green spaces, and wellness amenities, this location reflects our commitment to creating workplaces that support both
                professional growth and personal well being.
              </p>
            </div>
          </div>

          <div class="row" style="text-align: left;">

            <div class="col-3">
              <img src="/static/assets/img/dtf-assets/images/redesign/Walking_Path.jpg" alt="Logo" class="logo" />
            </div>

            <div class="col-7" style="text-align: left; color: black; font-size: 24px; font-family: 'corporateSRegular';">
              <p>With convenience, lifestyle, and community woven into the surroundings, our Ballantyne presence exemplifies Daimler
                Truck Financial Services’ dedication to creating spaces where employees can do their best work and build their
                future. It’s more than an office—it’s a destination for talent, innovation, and opportunity.</p>
            </div>

          </div>
          <br><br>
        </div>
      </div>
      <br><br>
    </section>

    <br>
    <br>

    <section class='mbfs-repay-banner-inner' style="background-color: white; display: flex; justify-content: center;">
      <div class="mbfs-repay-banner-inner__box">
        <div class="mbfs-repay-banner-inner__box--text2">
          <img src="/static/assets/img/dtf-assets/images/redesign/LifeatDTFS_Subtext_Transbckgrnd.png" alt="Logo"
            class="logo" />
          <br><br>
          <button class="mbfs-button-1" id="GEICOcta"
            (click)="GetQuote()">LinkedIn</button>
        </div>
      </div>
    </section>

    <br><br>

    <section class='mbfs-repay-banner-inner' style="background-color: #E6E6E6; display: flex; justify-content: center;">
      <div class="mbfs-repay-banner-inner__box" style="margin-left: 130px;">
        <div class="mbfs-repay-banner-inner__box--text2">
          <p style="text-align: left; color: black; font-size: 45px;">DTFS Fast Facts</p>
          <br>
          <img src="/static/assets/img/dtf-assets/images/redesign/Fast_Facts_TransBckgrnd.png" alt="Logo" class="logo">
        </div>
      </div>
    </section>

    <br><br>

    <section class='mbfs-repay-banner-inner'
      style="background-color: white; display: flex; text-align: left; color: black; justify-content: center;">
      <div class="mbfs-repay-banner-inner__box"  style="margin-left: 130px;">
        <div class="mbfs-repay-banner-inner__box--text2">
          <p style="text-align: left; color: black; font-size: 45px;">Our Convictions</p>
          <p style="text-align: left; color: black; font-size: 25px;">Our Culture Reflects Five Core Convictions-With People at the Center.</p>
          <br>
          <div class="row">
            <div class="col-3">
              <img src="/static/assets/img/dtf-assets/images/redesign/Shared_Values.png" alt="Logo" class="logo">
            </div>
            <div class="col" style="text-align: left; font-size: 17px;">
              <p style="font-size: 26px; font-weight: 500;">SHARED VALUES</p>
              <p>Trust, Authenticity, Respect and Integrity form the foundation of everything we do at DTFS.</p>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <img src="/static/assets/img/dtf-assets/images/redesign/People_Always.png" alt="Logo" class="logo">
            </div>
            <div class="col" style="text-align: left; font-size: 17px;">
              <p style="font-size: 26px; font-weight: 500;">PEOPLE ALWAYS</p>
              <p>We care about each other every day. Everyone is empowered and supported to develop as an individual. Our approach is
                agile and flexible, we foster diversity and inclusivity as one passionate fun-loving team.</p>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <img src="/static/assets/img/dtf-assets/images/redesign/Excellence.png" alt="Logo" class="logo">
            </div>
            <div class="col" style="text-align: left; font-size: 17px;">
              <p style="font-size: 26px; font-weight: 500;">EXCELLENCE</p>
              <p>Best results are achieved with an entrepreneurial mindset and by taking ownership. Driving efficiency and continuous
                improvement increase value.</p>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <img src="/static/assets/img/dtf-assets/images/redesign/Customer_Driven.png" alt="Logo" class="logo">
            </div>
            <div class="col" style="text-align: left; font-size: 17px;">
              <p style="font-size: 26px; font-weight: 500;">CUSTOMER DRIVEN</p>
              <p>Our success is based on relentlessly understanding customer needs, delivering smart solutions and creating best
                customer experiences.</p>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <img src="/static/assets/img/dtf-assets/images/redesign/Sustainability.png" alt="Logo" class="logo">
            </div>
            <div class="col" style="text-align: left; font-size: 17px;">
              <p style="font-size: 26px; font-weight: 500;">SUSTAINABILITY</p>
              <p> Long term orientation ensures our success for current and future generations, including a commitment to the
                environment, social responsibility and governance. </p>
            </div>
          </div>

        </div>
      </div>
    </section>

    <br><br><br><br>

    <section class='mbfs-repay-banner-inner' style="background-color: white; display: flex; justify-content: center;">
      <div class="mbfs-repay-banner-inner__box">
        <div class="mbfs-repay-banner-inner__box--text2">
          <img src="/static/assets/img/dtf-assets/images/redesign/SPECS_TransBckgrnd_lrg.png" alt="Logo" class="logo" />
        </div>
      </div>
    </section>

    <br><br><br>


  </div>

</body>